import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { generatePath } from 'react-router-dom';

import { Link } from '@ui/Link';
import { Stars } from '@ui/Stars';
import { publicMemberProfile } from '@urls';
import { RatingValues } from '@models';

import s from './UserReview.sss';

type Product = {
  name: string
  url: string
};

const ratingValueNumbers: Record<RatingValues, number> = {
  [RatingValues.Rating_1Star]: 1,
  [RatingValues.Rating_2Star]: 2,
  [RatingValues.Rating_3Star]: 3,
  [RatingValues.Rating_4Star]: 4,
  [RatingValues.Rating_5Star]: 5,
};

export type Review = {
  product?: Product | null
  authorUsername: string
  authorAvatarUrl: string
  authorShopName: string | null | undefined
  text?: string | null
  overallRating: RatingValues
  createdAt: string
};

type UserReviewProps = {
  review: Review
  className?: string
};

export const UserReview: React.FC<UserReviewProps> = ({
  review,
  className,
}) => {
  const authorProfileUrl = generatePath(
    publicMemberProfile,
    { username: review.authorUsername },
  );
  const { product } = review;
  const authorTitle = review.authorShopName || review.authorUsername;

  return (
    <div className={classNames(s.root, className)}>
      <Link
        theme="clean"
        to={authorProfileUrl}
      >
        <img
          className={classNames(s.avatar, 'lazyload')}
          data-src={review.authorAvatarUrl}
          alt={authorTitle}
        />
      </Link>

      <div className={s.reviewBlock}>
        <div className={s.firstLine}>
          <div>
            <Link to={authorProfileUrl}>{authorTitle}</Link>
          </div>
          <div className={s.date}>{dayjs(review.createdAt).format('DD.MM.YY HH:mm')}</div>
        </div>

        <Stars
          className={s.rating}
          value={ratingValueNumbers[review.overallRating]}
          readOnly={true}
        />

        {
          product
            && (
            <Link
              className={s.productLink}
              href={product.url}
            >
              {product.name}
            </Link>
            )
        }

        <div className={s.text}>
          {review.text}
        </div>
      </div>
    </div>
  );
};
